<!--<div *ngIf="!isPopulated" class="insights-cards">
        <div class="insights-card__content" style="margin-bottom: 30px;">
            <ft-spinner block="true"></ft-spinner>
        </div>
    </div>-->
<div edsGrid>
  <div class="container">
    <div edsRow>
      <div edsCol>
        <eds-marketo-form
          *ngIf="preferencesLoaded"
          [edsSpacing]="
            marginBottom && marginBottom !== 'auto' ? marginBottom : 'xl'
          "
          [marketoFormConfig]="formConfig"
          [marketoPreferencesResult]="userSubscriptionData"
          [retainFormAfterSubmission]="retainFormAfterSubmission"
          [id]="id"
          [successTitle]="successTitle"
          [successMsg]="successMsg"
          (formSubmit)="formAnalytics()"
          [hasUnsubscribeButton]="hasUnsubscribeButton"
          [unsubscribeButtonText]="unsubscribeButtonText"
        ></eds-marketo-form>
      </div>
    </div>
  </div>
</div>
